$(document).ready(function() { 

$('#section--stockists').css('opacity', '1');
  
var $linksus = $('.UnitedStates .mobile_h5').clone();
$('.us-list').html($linksus);

var $linksus = $('.Australia .mobile_h5').clone();
$('.au-list').html($linksus);

var $linksus = $('.Canada .mobile_h5').clone();
$('.can-list').html($linksus);

var $linksus = $('.Switzerland .mobile_h5').clone();
$('.sw-list').html($linksus);

  
$('.listright a:nth-child(1)').addClass('active');
 $('.stockist-item:nth-child(1) a.mobile_h5').addClass('active');
  
$(".list li a").click(function() {
  var cytext = $(this).attr('data-src');
  $('.stockists-box').hide();  
  $('.stockists-box.'+ cytext).fadeIn(); 
  $('.list li a').not(this).removeClass('active');
   $(this).addClass('active');
}); 

$(".UnitedStates .listright a").click(function() {
  var areatext = $(this).attr('data-val'); 
  $('.UnitedStates .stockist-item').hide();  
  $('.UnitedStates .stockist-details > div.'+ areatext).fadeIn();   
  $('.UnitedStates .listright a').not(this).removeClass('active');
   $(this).addClass('active');
});

$(".Australia .listright a").click(function() {
  var areatext = $(this).attr('data-val'); 
  $('.Australia .stockist-item').hide();  
  $('.Australia .stockist-details > div.'+ areatext).fadeIn();   
  $('.Australia .listright a').not(this).removeClass('active');
   $(this).addClass('active');
});

$(".Canada .listright a").click(function() {
  var areatext = $(this).attr('data-val'); 
  $('.Canada .stockist-item').hide();  
  $('.Canada .stockist-details > div.'+ areatext).fadeIn();   
  $('.Canada .listright a').not(this).removeClass('active');
   $(this).addClass('active');
});

  $(".Switzerland .listright a").click(function() {
  var areatext = $(this).attr('data-val'); 
  $('.Switzerland .stockist-item').hide();  
  $('.Switzerland .stockist-details > div.'+ areatext).fadeIn();   
  $('.Switzerland .listright a').not(this).removeClass('active');
   $(this).addClass('active');
});


 
  
  }); 

$('body').on('click', '.UnitedStates .stockist-item .mobile_h5', function(e) {
    $('.UnitedStates .stockist-item').find('.stockist-row').stop().slideUp();
    $(this).closest('.UnitedStates .stockist-item').find('.stockist-row').stop().slideToggle();
   $('.UnitedStates .stockist-item .mobile_h5').not(this).removeClass('active');
   $(this).addClass('active');
});

$('body').on('click', '.Australia .stockist-item .mobile_h5', function(e) {
    $('.Australia .stockist-item').find('.stockist-row').stop().slideUp();
    $(this).closest('.Australia .stockist-item').find('.stockist-row').stop().slideToggle();
  $('.Australia .stockist-item .mobile_h5').not(this).removeClass('active');
   $(this).addClass('active');
});

$('body').on('click', '.Canada .stockist-item .mobile_h5', function(e) {
    $('.Canada .stockist-item').find('.stockist-row').stop().slideUp();
    $(this).closest('.Canada .stockist-item').find('.stockist-row').stop().slideToggle();
   $('.Canada .stockist-item .mobile_h5').not(this).removeClass('active');
   $(this).addClass('active');
});

$('body').on('click', '.Switzerland .stockist-item .mobile_h5', function(e) {
    $('.Switzerland .stockist-item').find('.stockist-row').stop().slideUp();
    $(this).closest('.Switzerland .stockist-item').find('.stockist-row').stop().slideToggle();
  $('.Switzerland .stockist-item .mobile_h5').not(this).removeClass('active');
   $(this).addClass('active');
});


